/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TutorRouteImport } from './routes/tutor'
import { Route as ReadSourceIdRouteImport } from './routes/read/$sourceId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorRoute = TutorRouteImport.update({
  id: '/tutor',
  path: '/tutor',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadSourceIdRoute = ReadSourceIdRouteImport.update({
  id: '/read/$sourceId',
  path: '/read/$sourceId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/tutor': typeof TutorRoute
  '/read/$sourceId': typeof ReadSourceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/tutor': typeof TutorRoute
  '/read/$sourceId': typeof ReadSourceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/tutor': typeof TutorRoute
  '/read/$sourceId': typeof ReadSourceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/settings' | '/tutor' | '/read/$sourceId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/settings' | '/tutor' | '/read/$sourceId'
  id: '__root__' | '/' | '/settings' | '/tutor' | '/read/$sourceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRoute
  TutorRoute: typeof TutorRoute
  ReadSourceIdRoute: typeof ReadSourceIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutor': {
      id: '/tutor'
      path: '/tutor'
      fullPath: '/tutor'
      preLoaderRoute: typeof TutorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$sourceId': {
      id: '/read/$sourceId'
      path: '/read/$sourceId'
      fullPath: '/read/$sourceId'
      preLoaderRoute: typeof ReadSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRoute,
  TutorRoute: TutorRoute,
  ReadSourceIdRoute: ReadSourceIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
